import React,{ useEffect, useState } from "react";
import withFirst from "../../hoc/withFirst";
import SwiperProduct from "../../module/swiper-product/swiper-product";
import { Swiper, SwiperSlide } from 'swiper/react';
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"
import { FormattedMessage } from "react-intl";
import { useProduct } from "../../../hooks/batch-product";
import withSource from '../../../../hocs/source-only-scoll'
import { unitPrice } from "../../../../../utils/product";
import ShopTheLookSwiperProduct from "./shop-the-look-swiper-product/shopTheLookSwiperProduct";
import ShopTheLookEditor from './shop-the-look-editor/shopTheLookEditor'
import { BlackMask } from "../../../../components/mask";
import { useShopTheLook } from "./utils/shopTheLook";
import ReactDom from "react-dom";
import FlyToCart from "../../../listing/components/cart/fly-to-cart";
import { useQuery } from "../../../../hooks/common";


const Item = props =>{
    useStyles(classes);
    const { innerRef, shopTheLookData, updateShopTheLook, productHooks, pageParamsId } = props;
    const { selectedProduct, selectedVariant, selectVariant } = productHooks;
    const { shoppableProducts, mainShoppableProduct, shopTheLookProductId, total, originalTotal, promotionTitle } = shopTheLookData || {}

    const itemSelected = shoppableProducts?.filter(shoppableProduct => shoppableProduct?.selected)

    const [openEditor, setOpenEditor] = useState(false) 
    const [editorData, setEditorData] = useState(null)
    const {cartImage, loading, findSameVariant, productsAddToCart} = useShopTheLook()

    useEffect(() => {
        if(selectedVariant && selectedProduct){
            if(!shopTheLookData){
                let params = {
                    "shopTheLookProductId": pageParamsId,
                }
                if (selectedVariant) {
                    params.mainShoppableProduct = {
                        "variantId": selectedVariant?.id,
                        "qty": 1,
                        "selected": true
                    }
                }
                updateCommit(params)
            } else {
                changeVariant('',selectedVariant?.id,1,true,selectedProduct)
            }
        }
    }, [selectedVariant])

    const productConfirm = async () => {
        let list = [...shopTheLookData?.shoppableProducts]
        const mainProduct = shopTheLookData?.mainShoppableProduct || {}
        const mainVarinat = mainProduct?.product?.variants?.find(s => s.id == mainProduct?.variantId)
        let formatedList = []
        formatedList.unshift({
            quantity: mainProduct?.qty,
            variant: mainVarinat,
            isSelect: true,
            image: mainVarinat?.image,
            product: mainProduct?.product,
            product_position: '1'
        })
        list.forEach((l, i)=> {
            l.selected &&
            formatedList.push({
                quantity: l.qty,
                variant: l?.product?.variants?.find(v => v.id == l?.variantId),
                isSelect: true,
                product: l?.product,
                product_position: i+2
            })
        })
        await productsAddToCart(formatedList, selectedProduct, shopTheLookProductId)
    }

    const updateCommit = (data) => {
        updateShopTheLook(data)
        closeEditor()
    }

    const closeEditor = () => {
        setEditorData(null)
        setOpenEditor(false)
    }
    // useEffect(() => {
    //     console.log(shopTheLookData)
    // }, [shopTheLookData])

    const changeVariant = (oldVariantId, newVariantId, qty, isMain, product) =>{
        // console.log(oldVariantId, newVariantId, qty, isMain, product, pageParamsId)
        let obj = {...shopTheLookData}
        let mainObj = {qty:1,selected:true}
        if(isMain){
            obj.shopTheLookProductId = pageParamsId
            mainObj.variantId = newVariantId
            obj.mainShoppableProduct = mainObj
            // selectVariant(newVariantId)
        }
        obj?.shoppableProducts?.forEach(o => {
            if(o.variantId == oldVariantId){
                o.selected = true
                o.variantId = newVariantId
                o.qty = qty
            }
            o.product = null
        })
        updateCommit(obj)
    }

    const productSelect = (variantId, flag) => {
        let obj = {...shopTheLookData}
        obj?.shoppableProducts?.forEach(o => {
            if(o.variantId == variantId){
                o.selected = flag
            }
            o.product = null
        })
        updateCommit(obj)
    }

    return <div 
            id="shopTheLookNav"
            ref={innerRef} 
            data-title="product"
            data-position={2}
            data-type={20}
            data-content={'shop the look'}
            {...props}>
        {
            shopTheLookData?.mainShoppableProduct && <div className={classes.ProductShopTheLook}>
                <div className={classes.Hd}>
                    <span>
                        <FormattedMessage id="shop_the_look" defaultMessage="Shop the Look" />
                    </span>

                    <span className={classes.NumSet}>
                        {itemSelected?.length && (itemSelected?.length + 1) || 0} <FormattedMessage id="items" defaultMessage={'Items'}/> <FormattedMessage id="set" defaultMessage={"Set"}/>
                    </span>
                </div>

                <div className={classes.Bd}>
                    <Swiper 
                        spaceBetween={13}
                        slidesPerView='auto'
                        onSlideChange={(swiper) => console.log()}
                        onSwiper={(swiper) => console.log()}
                    >
                        <SwiperSlide className={`${classes.SwiperItem} ${classes.FirstSwiper}`}>
                            <ShopTheLookSwiperProduct 
                                product={mainShoppableProduct?.product} 
                                openEditor={(product, variant, color) => {
                                    setOpenEditor(true)
                                    setEditorData({
                                        color,
                                        product,
                                        variant,
                                        isMain: true
                                    })
                                }}
                                column={'shop the look'}
                                sensors={{
                                    resourcepage_title: "product",
                                    resource_position: "2",
                                    resource_content: "shop the look",
                                    resource_type: '20',
                                }}
                                data={mainShoppableProduct}
                                position={0} 
                                isBeautyLook={false} 
                                noAction={true}
                                />
                        </SwiperSlide>

                        <SwiperSlide className={`${classes.addIcon}`}>
                            <span className={classes.withMore}>{'+'}</span>
                        </SwiperSlide>

                        {
                            shoppableProducts?.map((item,index) =><SwiperSlide className={classes.SwiperItem} key={index}>
                                <ShopTheLookSwiperProduct 
                                    product={item?.product} 
                                    data={item}
                                    openEditor={(product, variant, color) => {
                                        setOpenEditor(true)
                                        setEditorData({
                                            color,
                                            product,
                                            variant,
                                            isMain: false
                                        })
                                    }}
                                    column={'shop the look'}
                                    sensors={{
                                        resourcepage_title: "product",
                                        resource_position: "2",
                                        resource_content: "shop the look",
                                        resource_type: '20',
                                    }}
                                    position={index+1} 
                                    isBeautyLook={false}
                                    productSelect={(variantId, flag) => productSelect(variantId, flag)}
                                    />
                            </SwiperSlide>)
                        }
                    </Swiper>
                </div>

                {
                    total && 
                    <div className={classes.totalBox}>
                        {/* {
                            promotionTitle &&
                            <span className={classes.offInfo}>
                                <span>{promotionTitle}</span> 
                            </span>
                        } */}
                        <span><FormattedMessage id="total" defaultMessage={"Total"}/>:</span>
                        <span className={classes.realPrice}>{total ? unitPrice(total): '0.00'}</span>
                        {
                            originalTotal &&
                            <span className={classes.delPrice}>{unitPrice(originalTotal)}</span>
                        }
                        
                    </div>
                }
                <div className={classes.buyTogetherBtn} 
                     onClick={(e)=> productConfirm()}>
                    {
                        promotionTitle &&
                        <span className={classes.offInfo}>
                            <span className={classes.offTriangle}></span>
                            <span className={classes.offTxt}>{promotionTitle}</span> 
                            {/* <span> this is a promition Title </span> */}
                        </span>
                    }
                    <FormattedMessage id="buy_together"/>
                </div>

                {
                    openEditor &&
                    <>
                        <BlackMask onClick={() => closeEditor()}/>
                        <ShopTheLookEditor 
                            showEditor={openEditor}
                            product={editorData?.product}
                            color={editorData?.color}
                            isMain={editorData?.isMain}
                            onClose={() => closeEditor()}
                            productId={editorData?.product?.id}
                            changeVariant={(oldVariantId, newVariantId, qty, isMain, product) => changeVariant(oldVariantId, newVariantId, qty, isMain, product)}
                            variant={editorData?.variant}
                            />
                    </>
                    
                }
                
            </div>            
        }

        {
            cartImage && (typeof window !== 'undefined') && ReactDom.createPortal(<FlyToCart image={cartImage} />, document.getElementById('root'))
        }
    </div>
};

const ProductShopTheLook = props =>{
    const query = useQuery();
    useEffect(() =>{
        if(query?.go_shop_look){
            // document.getElementById("shopTheLookNav")?.scrollIntoView?.({
            //     behavior: 'smooth',
            //     block: 'center'
            // })
            let domCurrent = document.getElementById("shopTheLookNav");
            let currentOffsetTop = domCurrent.offsetTop + domCurrent.offsetParent.offsetTop;
            // console.log('currentOffsetTop', currentOffsetTop)

            window.scrollTo({
                top: currentOffsetTop - 100,
                behavior: 'smooth'
            })
        }
    },[]);

    return <>
        <Item {...props}/>
    </>
}

export default ProductShopTheLook;